export const KEYS = {
  DEFAULT: {
    LICENSE_ERROR: 'Lizenz Fehler',
    ERROR_LICENSE_INVALID: 'Es wurde keine gültige Lizenz gefunden.',
    ERROR_LICENSE_EXPIRED: 'Die Lizenz ist nicht mehr gültig. Anbei werden die Lizenzdaten ausgegeben.',
    WARNING_LICENSE_EXPIRES_SOON: 'Achtung: Die myMedax Lizenz läuft in [[numDaysLeft]] Tagen ab. Bitte denken Sie daran, die Lizenz vor Ablauf zu erneuern.',
    SERVER_UNREACHABLE: 'Server nicht erreichbar',
    ERROR_SERVER_UNREACHABLE: 'Der Lizenzserver konnte nicht kontaktiert werden. Bitte prüfen Sie die Netzwerkverbindung und versuchen Sie es später erneut.',
    SERVER_ERROR: 'Serverfehler',
    ERROR_SERVER_ERROR: 'Bei der Kommunikation mit dem Lizenzserver ist ein Fehler aufgetreten.'
  }
};
